<template>
    <div class="row h-100">
        <div class="col-12 d-none d-md-block col-md-5">
            <div class="left__auth_block">
                <a class="header__logo" :href="homelink">
                    <img src="/img/logo_white.png" alt="">
                </a>
                <h2 class="mb-4">{{ get_translation_constant('text_no_account') }}</h2>
                <a class="btn btn__medium btn__black mb-4" :href="registerlink">{{
                        get_translation_constant('text_signup')
                    }}</a>
                <p>{{ get_translation_constant('text_get_free_postal_address') }}</p>
            </div>
        </div>
        <div class="col-12 col-md-6 offset-md-1 col-lg-5 offset-lg-2">
            <h2>{{ get_translation_constant('text_login_to_account') }}</h2>
            <form @submit.prevent="login()">
                <div class="form__col" :class="hasError('email')">
                    <label for="email">{{ get_translation_constant('text_email') }}</label>
                    <input v-model="form.email" class="form__control" id="email" name="email" type="email"
                           :placeholder="get_translation_constant('text_entry_email')">
                    <div class="form__error" v-if="hasErrorMessage('email')">
                        {{ hasErrorMessage('email') }}
                    </div>
                </div>
                <div class="form__col" :class="hasError('password')|| hasError('location')">
                    <label for="password">{{ get_translation_constant('text_password') }}</label>
                    <input v-model="form.password" class="form__control" id="password" name="password" type="password"
                           :placeholder="get_translation_constant('text_entry_password')">
                    <div class="form__error" v-if="hasErrorMessage('password')">
                        {{ hasErrorMessage('password') }}
                    </div>
                    <div class="form__error" v-if="hasErrorMessage('location')">
                        {{ get_translation_constant('text_location_error_login_message') }}
                    </div>
                    <div class="form__error" v-if="facebookloginerror==='has-error'" style="display: block">
                        {{ get_translation_constant('text_facebook_login_error') }}
                    </div>
                </div>

                <div class="form__col d-flex justify-content-between align-items-center">
                    <a class="forgot_link" :href="forgottenlink">{{
                            get_translation_constant('text_forgot_password')
                        }}</a>
                    <button class="btn btn__medium btn__green" @click.prevent="login">
                        {{ get_translation_constant('text_login') }}
                    </button>
                </div>

                <div class="form__hr_line"><span>{{ get_translation_constant('text_or') }}</span></div>

                <div class="form__col form__col_last">
                    <a class="btn btn__block btn__medium btn__facebook" :href="socialloginurl">
                        <svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.64 11.08l.44-3.56H6.7V5.25c0-1.03.28-1.73 1.7-1.73h1.81V.34A23.2 23.2 0 007.56.2c-2.62 0-4.4 1.66-4.4 4.7v2.62H.2v3.56h2.96v9.12h3.53v-9.12h2.95z"
                                fill="#fff"/>
                        </svg>
                        Facebook login</a>
                </div>
            </form>
        </div>
        <div class="col-12 d-md-none col-md-5 mt-5">
            <h5>{{ get_translation_constant('text_facebook_login') }}</h5>
            <p><a :href="registerlink">{{ get_translation_constant('text_signup') }}</a>,
                {{ get_translation_constant('text_get_free_postal_address') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            errors: [],
            form: {
                locale: '',
                email: '',
                password: '',
            },
        }
    },
    props: {
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        loginurl: {
            type: [String]
        },
        socialloginurl: {
            type: [String]
        },
        redirect: {
            type: [String]
        },
        registerlink: {
            type: [String]
        },
        forgottenlink: {
            type: [String]
        },
        homelink: {
            type: [String]
        },
        facebookloginerror: {
            type: [String],
            default: ''
        }

    },
    methods: {
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        login() {
            axios.post(this.loginurl, this.form).then(response => {

                if (response.status === 200) {
                    //set cookie access_token
                    this.$cookies.set('access_token', response.data['access_token'], response.data['expired_at']);
                    window.location.replace(this.redirect);
                    window.location.href = this.redirect;
                }


            }).catch(error => {
                if (error.response.status === 400) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        socialLogin() {

        },
        hasError(error) {
            if (this.errors[error])
                return 'has__error';
        },

        hasErrorMessage(error) {
            if (this.errors[error]) {
                if (Array.isArray(this.errors[error])) {
                    return this.errors[error][0]
                }
                return this.errors[error];
            }

        },
    },
    computed: {},
    mounted() {
        this.form.locale = this.lng
    }
}
</script>

<style scoped>

</style>
